import { ServiceBase, Result } from "./ServiceBase";

export default class ExportService extends ServiceBase {

    public static async rebuild(payload: any): Promise<Result<boolean>> {

        var result = await this.requestJson<boolean>({
            url: `/api/export/triggerprices`,
            method: "POST",
            data: payload
        });

        return result;
    }
}
